export default __webpack_public_path__ + "assets/images/f62859a0671d2533af61653c15e3e2e1.png";